var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownloadGooglePlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 173 50",
  preserveAspectRatio: "xMidYMid meet"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M166.593 50H6.407C2.885 50 0 47.186 0 43.75V6.25C0 2.814 2.885 0 6.407 0h160.186C170.115 0 173 2.814 173 6.25v37.5c0 3.436-2.885 6.25-6.407 6.25"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#a6a6a6",
  d: "M166.593 1.002c2.966 0 5.38 2.354 5.38 5.248v37.5c0 2.894-2.414 5.248-5.38 5.248H6.407c-2.966 0-5.38-2.354-5.38-5.248V6.25c0-2.894 2.414-5.248 5.38-5.248zm0-1.002H6.407C2.885 0 0 2.814 0 6.25v37.5C0 47.186 2.885 50 6.407 50h160.186c3.522 0 6.407-2.814 6.407-6.25V6.25c0-3.436-2.885-6.25-6.407-6.25"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M13.372 9.424c-.376.384-.594.982-.594 1.757v27.644c0 .775.218 1.374.594 1.758l.093.084 15.88-15.484v-.366L13.466 9.333z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "m34.634 30.347-5.288-5.164v-.366l5.294-5.164.118.067 6.27 3.48c1.79.988 1.79 2.613 0 3.606l-6.27 3.474z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#c)",
  d: "M34.759 30.28 29.345 25 13.372 40.583c.595.61 1.564.683 2.666.073z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#d)",
  d: "M34.759 19.72 16.037 9.344c-1.102-.603-2.072-.53-2.666.08L29.346 25z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M60.765 12.805c0 1.043-.32 1.88-.952 2.503q-1.09 1.11-2.829 1.11c-1.107 0-2.052-.377-2.827-1.123-.777-.756-1.164-1.684-1.164-2.795q0-1.666 1.164-2.79c.775-.75 1.72-1.129 2.827-1.129.551 0 1.077.111 1.578.317.5.208.907.49 1.202.836l-.67.66c-.514-.593-1.214-.885-2.11-.885q-1.21-.001-2.101.83-.883.835-.883 2.16c0 .885.295 1.612.883 2.168.594.549 1.294.83 2.101.83.857 0 1.578-.281 2.147-.836q.561-.55.644-1.52h-2.79v-.904h3.722c.045.196.058.385.058.568M66.67 9.673h-3.496v2.375h3.152v.903h-3.152v2.375h3.497v.92h-4.487V8.754h4.487zM70.839 16.247h-.99V9.673h-2.145v-.92h5.281v.92H70.84zM76.807 16.247V8.753h.989v7.494zM82.177 16.247h-.982V9.673h-2.153v-.92h5.287v.92h-2.152zM94.328 15.283q-1.136 1.137-2.816 1.136-1.688 0-2.822-1.136-1.133-1.135-1.133-2.783t1.133-2.783q1.134-1.136 2.822-1.136 1.672-.002 2.81 1.142c.762.763 1.139 1.685 1.139 2.777q0 1.648-1.133 2.783m-4.906-.628q.853.841 2.09.842c.82 0 1.52-.281 2.084-.842q.855-.844.857-2.155c0-.873-.288-1.594-.857-2.155-.564-.56-1.264-.842-2.084-.842q-1.237 0-2.09.842-.855.843-.857 2.155c0 .873.288 1.594.857 2.155M96.85 16.247V8.753h1.2l3.736 5.828h.044l-.044-1.44V8.753h.989v7.494h-1.032l-3.911-6.116h-.044l.044 1.447v4.669zM87.314 27.19c-3.01 0-5.469 2.235-5.469 5.318 0 3.058 2.459 5.315 5.469 5.315 3.016 0 5.475-2.257 5.475-5.315 0-3.083-2.459-5.317-5.475-5.317m0 8.54c-1.652 0-3.073-1.33-3.073-3.222 0-1.917 1.421-3.224 3.073-3.224s3.079 1.307 3.079 3.224c0 1.892-1.428 3.222-3.08 3.222m-11.932-8.54c-3.017 0-5.47 2.235-5.47 5.318 0 3.058 2.453 5.315 5.47 5.315 3.014 0 5.468-2.257 5.468-5.315 0-3.083-2.454-5.317-5.468-5.317m0 8.54c-1.654 0-3.08-1.33-3.08-3.222 0-1.917 1.426-3.224 3.08-3.224 1.651 0 3.072 1.307 3.072 3.224 0 1.892-1.421 3.222-3.072 3.222m-14.2-6.91v2.26h5.532c-.162 1.262-.594 2.19-1.257 2.837-.808.781-2.065 1.649-4.274 1.649-3.404 0-6.07-2.68-6.07-6s2.666-6 6.07-6c1.84 0 3.18.701 4.168 1.61l1.632-1.592c-1.382-1.287-3.221-2.276-5.8-2.276-4.668 0-8.591 3.704-8.591 8.258s3.923 8.257 8.59 8.257c2.524 0 4.419-.806 5.908-2.318 1.527-1.49 2.003-3.583 2.003-5.274 0-.525-.045-1.008-.125-1.41zm58.061 1.752c-.45-1.19-1.839-3.381-4.667-3.381-2.804 0-5.138 2.154-5.138 5.317 0 2.978 2.31 5.315 5.407 5.315a5.44 5.44 0 0 0 4.543-2.356l-1.859-1.208c-.619.885-1.464 1.47-2.684 1.47-1.213 0-2.083-.542-2.64-1.61l7.29-2.942zm-7.432 1.77a2.95 2.95 0 0 1 2.846-3.1c.952 0 1.759.464 2.028 1.128zm-5.925 5.158h2.396V21.875h-2.396zm-3.925-9.125h-.08c-.538-.622-1.565-1.184-2.866-1.184-2.73 0-5.225 2.337-5.225 5.334 0 2.98 2.496 5.298 5.225 5.298 1.301 0 2.328-.567 2.866-1.207h.08v.762c0 2.033-1.113 3.125-2.909 3.125-1.464 0-2.372-1.031-2.747-1.898l-2.084.848c.6 1.41 2.191 3.144 4.831 3.144 2.81 0 5.18-1.613 5.18-5.536v-9.547h-2.271zm-2.74 7.355c-1.652 0-3.035-1.349-3.035-3.205 0-1.873 1.383-3.24 3.034-3.24 1.628 0 2.911 1.366 2.911 3.24 0 1.856-1.283 3.205-2.91 3.205m31.242-13.855h-5.732V37.5h2.39v-5.92h3.342c2.654 0 5.257-1.874 5.257-4.853s-2.609-4.852-5.257-4.852m.062 7.531h-3.404v-5.358h3.404a2.744 2.744 0 0 1 2.803 2.679c0 1.209-1.018 2.68-2.803 2.68m14.774-2.245c-1.727 0-3.522.744-4.261 2.392l2.121.867c.457-.867 1.296-1.148 2.183-1.148 1.24 0 2.498.726 2.517 2.01v.163c-.433-.244-1.358-.604-2.497-.604-2.285 0-4.612 1.226-4.612 3.515 0 2.094 1.871 3.442 3.974 3.442 1.608 0 2.496-.707 3.053-1.53h.082v1.207h2.308V31.48c0-2.77-2.121-4.32-4.868-4.32m-.288 8.562c-.782 0-1.871-.378-1.871-1.323 0-1.21 1.358-1.673 2.534-1.673 1.052 0 1.546.226 2.185.525-.188 1.446-1.464 2.471-2.848 2.471m13.566-8.22-2.747 6.773h-.082l-2.84-6.773h-2.577l4.267 9.466-2.435 5.267h2.497l6.576-14.733zM137.034 37.5h2.396V21.875h-2.396z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 158.277,
  x2: 148.514,
  y1: 47.52,
  y2: -17.974,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00a0ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.007,
  stopColor: "#00a1ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.26,
  stopColor: "#00beff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.512,
  stopColor: "#00d2ff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.76,
  stopColor: "#00dfff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00e3ff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 186.123,
  x2: -225.752,
  y1: 25.008,
  y2: 25.008,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ffe000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.409,
  stopColor: "#ffbd00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.775,
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff9c00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: 149.191,
  x2: 91.022,
  y1: 58.925,
  y2: 214.047,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ff3a44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#c31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: -32.526,
  x2: -6.536,
  y1: -77.085,
  y2: -7.8,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32a071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.069,
  stopColor: "#2da771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.476,
  stopColor: "#15cf74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.801,
  stopColor: "#06e775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00f076"
})))));
export default SvgDownloadGooglePlay;